import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Callout } from '@node-space/ui-components'
import { BeneficiaryTransferDestination } from 'types/beneficiaries'

interface BankAccountRequirmentsCalloutProps {
  transferDestination: BeneficiaryTransferDestination
}

export const BankAccountRequirmentsCallout = ({
  transferDestination,
}: BankAccountRequirmentsCalloutProps) => {
  const { t } = useTranslation()

  const fieldsLabel = useMemo(() => {
    if (transferDestination === BeneficiaryTransferDestination.INTERNATIONAL) {
      return t('contacts.internationalBankAccountRequirements')
    }

    return t('contacts.localUsdBankAccountRequirements')
  }, [transferDestination])

  return (
    <Callout variant="warning">
      <p className="text-body-regular text-inherit">{fieldsLabel}</p>
    </Callout>
  )
}
